import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from '@/components/loading';
import { AccessKeyDetail } from '@/components/access-key-detail';
import { useMeQuery, useUpdateAccessKeyMutation } from '@/api/user';
import { useNow } from '@/hooks/use-now';

const SettingsAccessKeyDetail = () => {
  const { keyId } = useParams<{ keyId: string }>();
  const navigate = useNavigate();
  const now = useNow();
  const { data: me, isLoading } = useMeQuery();
  const [updateAccessKey, { isLoading: isUpdating }] =
    useUpdateAccessKeyMutation();

  const accessKey = me?.keys.find((k) => k.id === keyId);

  const onUpdate = useCallback(
    async (scopes: string[], expiresAt?: string | null) => {
      if (keyId) {
        await updateAccessKey({ id: keyId, scopes, expiresAt }).unwrap();
      }
    },
    [keyId, updateAccessKey],
  );

  const onBack = useCallback(() => {
    navigate('/settings/account/access-keys');
  }, [navigate]);

  if (isLoading) {
    return <Loading />;
  }

  if (!accessKey) {
    return <Loading />;
  }

  return (
    <AccessKeyDetail
      accessKey={accessKey}
      now={now}
      onUpdate={onUpdate}
      onBack={onBack}
      isUpdating={isUpdating}
    />
  );
};

export { SettingsAccessKeyDetail };
